import { render, staticRenderFns } from "./SitioProcesosInspecciones.vue?vue&type=template&id=06610d8b"
import script from "./SitioProcesosInspecciones.vue?vue&type=script&lang=js"
export * from "./SitioProcesosInspecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports